import React from "react";
import idx from "idx";
import PanelGroup from "react-panelgroup";
import windowSize from "react-window-size";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { push } from "react-router-redux";
import { EDITOR_ITEMS, WIDGETS } from "../../constants";
import { objToArr } from "../../helpers";
import ActionCreators from "../../redux/actions";
import Styles from "./Editor.styles";
import LoadingOverlay from "../../components/LoadingOverlay";
import EditorLayout from "../../components/EditorLayout";
import Button from "../../components/UIKit/Button";
// import Spacer from '../../components/Spacer';
import PlayerContainer from "../PlayerContainer";
import ProjectName from "../../components/ProjectName";
import ProjectWidgets from "../../components/ProjectWidgets";
import ScenesPanel from "../../components/ScenesPanel";
import LayersPanel from "../../components/LayersPanel";
import WidgetsPanel from "../../components/WidgetsPanel";
import Inspector from "../Inspector";

import { uploadFile } from "../../helpers/fileHelpers";
// test project id AA4LCwAABwcNCwMDBAEACw

class Editor extends React.Component {
  constructor() {
    super();

    this.onSceneCreate = this.onSceneCreate.bind(this);
    this.onSceneDelete = this.onSceneDelete.bind(this);
    this.onLayerCreate = this.onLayerCreate.bind(this);
    this.onLayerDelete = this.onLayerDelete.bind(this);
    this.onWidgetCreate = this.onWidgetCreate.bind(this);
    this.onWidgetDelete = this.onWidgetDelete.bind(this);
    this.onSceneSelect = this.onSceneSelect.bind(this);
    this.onLayerSelect = this.onLayerSelect.bind(this);
    this.onWidgetSelect = this.onWidgetSelect.bind(this);
    this.onPrefabSelect = this.onPrefabSelect.bind(this);
    this.onPrefabCreate = this.onPrefabCreate.bind(this);
    this.onPrefabBreak = this.onPrefabBreak.bind(this);
    this.onPrefabDelete = this.onPrefabDelete.bind(this);
    this.onPrefabDrop = this.onPrefabDrop.bind(this);
  }

  componentWillReceiveProps(newProps) {
    /* const { sceneId } = newProps.match.params;
    if (sceneId && sceneId !== this.props.selectedSceneId) {
      this.props.selectInspectorItem(sceneId, EDITOR_ITEMS.SCENE);
    } else if (newProps.projects && !this.props.selectedSceneId) {
      const { sceneId, projectId } = newProps.match.params;
      const project = idx(newProps, _ => _.projects[projectId]);
      const scenes = idx(project, _ => _.scenes);
      const scene = sceneId || scenes ? Object.keys(scenes)[0] : null;

      if (scene) {
        this.props.selectInspectorItem(scene, EDITOR_ITEMS.SCENE);
      }
    } */
  }

  onSceneCreate(sceneData) {
    const { projectId } = this.props.match.params;
    sceneData.panorama.map((panorama, index) => {
      this.props.firebase
        .pushWithMeta(`/projects/${projectId}/scenes`, {
          name:
            sceneData.panorama.length > 1
              ? `${sceneData.name}_${index}`
              : sceneData.name
        })
        .then(snapshot => {
          if (sceneData.panorama && sceneData.panorama.length > 0) {
            const options = {
              name: file => `${file.name}/${Date.now()}`
            };
            this.props.setLoadingScene(snapshot.key);

            uploadFile(
              this.props.firebase,
              `files/${projectId}/${snapshot.key}/panorama`,
              `/projects/${projectId}/scenes/${snapshot.key}/panorama`,
              panorama
            ).then(() => this.props.setSceneLoaded(snapshot.key));
            // this.props.firebase
            //   .uploadFile(`files/${projectId}`, panorama, null, options)
            //   .then(res => {
            //     const { uploadTaskSnaphot: { downloadURL = {} } = {} } = res;
            //     this.props.firebase
            //       .updateWithMeta(
            //         `/projects/${projectId}/scenes/${snapshot.key}/panorama`,
            //         {
            //           downloadURL
            //         }
            //       )
            //       .then(() => this.props.setSceneLoaded(snapshot.key));
            //   });
            return true;
          }
        });
    });
  }

  onSceneDelete(id) {
    const { projectId } = this.props.match.params;

    this.props.firebase.remove(`projects/${projectId}/scenes/${id}`);
  }

  onLayerCreate(layerData) {
    const { projectId, sceneId } = this.props.match.params;

    if (layerData.panorama) {
      layerData.panorama.map((panorama, index) => {
        this.props.firebase
          .pushWithMeta(`/projects/${projectId}/scenes/${sceneId}/layers`, {
            name:
              layerData.panorama.length > 1
                ? `layer_${layerData.name}_${index}`
                : layerData.name
          })
          .then(snapshot => {
            this.props.firebase.uploadFiles(
              `files/${projectId}`,
              [panorama],
              `/projects/${projectId}/scenes/${sceneId}/layers/${snapshot.key}`
            );
          });
        return panorama;
      });
    } else {
      this.props.firebase.pushWithMeta(
        `/projects/${projectId}/scenes/${sceneId}/layers`,
        {
          name: layerData.name
        }
      );
    }
  }

  onLayerDelete(id) {
    const { projectId, sceneId } = this.props.match.params;

    this.props.firebase.remove(
      `/projects/${projectId}/scenes/${sceneId}/layers/${id}`
    );

    // @todo - select first layer in scene
  }

  onWidgetCreate(widget) {
    const { projectId, sceneId, layerId, widgetId } = this.props.match.params;
    this.props.firebase.pushWithMeta(
      `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets`,
      {
        name: widget,
        type: widget
      }
    );
  }

  onWidgetDelete(id) {
    const { projectId, sceneId, layerId } = this.props.match.params;
    this.props.firebase.remove(
      `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${id}`
    );

    // @todo - select first layer in scene
  }

  onSceneSelect(props) {
    const { projectId } = this.props.match.params;
    const project = idx(this.props, _ => _.projects[projectId]);
    const scene = project.scenes[props.id];
    const layers = objToArr(scene.layers);
    let layer = null;
    if (layers.includes("_generated")) {
      layer = "_generated";
    } else if (layers.length > 0) {
      layer = layers[0];
    }

    this.props.selectInspectorItem(props.id, EDITOR_ITEMS.SCENE);
    if (layer) {
      this.props.push(`/editor/${projectId}/${scene.id}/${layer.key}`);
    } else {
      this.props.push(`/editor/${projectId}/${scene.id}`);
    }
  }

  onLayerSelect(props) {
    let { projectId, sceneId } = this.props.match.params;
    const project = idx(this.props, _ => _.projects[projectId]);
    const scenes = idx(project, _ => _.scenes);
    if (!sceneId && scenes.length > 0) {
      sceneId = scenes[0].id;
    }
    this.props.selectInspectorItem(props.id, EDITOR_ITEMS.LAYER, "editor");
    this.props.push(`/editor/${projectId}/${sceneId}/${props.id}`);
  }

  onWidgetSelect(props) {
    const { projectId, sceneId, layerId } = this.props.match.params;

    this.props.selectInspectorItem(props.id, EDITOR_ITEMS.WIDGET, "editor");
    this.props.push(`/editor/${projectId}/${sceneId}/${layerId}/${props.id}`);
  }

  onPrefabSelect(props) {
    this.props.selectInspectorItem(props.id, EDITOR_ITEMS.WIDGET, "editor");
  }

  onPrefabCreate(widget) {
    const { projectId, sceneId, layerId, widgetId } = this.props.match.params;
    this.props.firebase
      .pushWithMeta(`/projects/${projectId}/prefabs`, widget)
      .then(snapshot => {
        this.props.firebase.updateWithMeta(
          `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}`,
          { prefabId: snapshot.ref.key }
        );
      });
  }

  onPrefabBreak() {
    const { projectId, sceneId, layerId, widgetId } = this.props.match.params;
    this.props.firebase.remove(
      `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}/prefabId`
    );
  }

  onPrefabDrop(prefabId, position) {
    const { projectId, sceneId, layerId } = this.props.match.params;
    var prefab = {
      ...this.props.projects[projectId].prefabs[prefabId],
      prefabId: prefabId,
      dropPosition: position
    };
    delete prefab.prefab;
    this.props.firebase.pushWithMeta(
      `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets`,
      prefab
    );
  }

  onPrefabDelete(prefabId) {
    const { projectId } = this.props.match.params;
    for (var sceneId in this.props.projects[projectId].scenes) {
      for (var layerId in this.props.projects[projectId].scenes[sceneId]
        .layers) {
        for (var widgetId in this.props.projects[projectId].scenes[sceneId]
          .layers[layerId].widgets) {
          if (
            this.props.projects[projectId].scenes[sceneId].layers[layerId]
              .widgets[widgetId].prefabId === prefabId
          ) {
            this.props.firebase.remove(
              `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}/prefabId`
            );
          }
        }
      }
    }
    this.props.firebase.remove(`/projects/${projectId}/prefabs/${prefabId}`);
    //this.props.firebase.remove(`/projects/${projectId}/prefabs`);
  }

  prepareItems(items, icon = null, disabledItems) {
    const output = objToArr(Object.assign({}, items)).map(item => {
      const tmp = item;
      tmp.id = tmp.key;
      tmp.text = tmp.name;
      if (icon) {
        tmp.icon = icon;
      }

      if (disabledItems && disabledItems.includes(tmp.key)) {
        tmp.secondaryIcon = "fa fa-spinner fa-spin";
      } else {
        tmp.secondaryIcon = null;
      }

      return tmp;
    });

    return output;
  }

  prepareWidgets(items) {
    const { projectId } = this.props.match.params;
    const project = idx(this.props, _ => _.projects[projectId]);
    const prefabs = project.prefabs;
    return this.prepareItems(items).map(item => ({
      ...item,
      icon:
        item.type === WIDGETS.INSTANCE
          ? `icon-${prefabs[item.prefab].type}`
          : `icon-${item.type}`,
      text:
        item.type === WIDGETS.INSTANCE ? `${item.text} (instance)` : item.text,
      secondaryIcon: item.prefabId ? "icon-prefab" : null
    }));
  }

  render() {
    if (!this.props.projectsRequested || this.props.projectsRequesting) {
      return <LoadingOverlay />;
    }

    let { projectId, sceneId, layerId, widgetId } = this.props.match.params;

    const project = idx(this.props, _ => _.projects[projectId]);

    const { loadingScenes: disabledItems } = this.props;
    const scenes = this.prepareItems(
      idx(project, _ => _.scenes),
      "icon-sphere",
      disabledItems
    );
    if (!sceneId && scenes.length > 0) {
      sceneId = scenes[0].id;
    }

    const layers = this.prepareItems(
      idx(project, _ => _.scenes[sceneId].layers),
      "icon-layer"
    );

    if (!layerId) {
      if (layers.includes("_generated")) {
        layerId = layers.indexOf("_generated");
      } else if (layers.length > 0) {
        layerId = layers[0];
      }
    }

    const widgets =
      sceneId && layerId
        ? this.prepareWidgets(
            idx(project, _ => _.scenes[sceneId].layers[layerId].widgets)
          )
        : [];

    return (
      <EditorLayout
        toolbar={[
          <ProjectName>{project.name || ""}</ProjectName>,
          <Button
            size="xs"
            onClick={() => {
              this.props.history.push(`/map-editor/${projectId}`);
            }}
          >
            Map editor
          </Button>,
          <Button
            size="xs"
            onClick={() => {
              this.props.history.push(`/projects/${projectId}`);
            }}
          >
            Project settings
          </Button>
          // <Button size="xs">Align scenes</Button>,
          // <Spacer />,
        ]}
        profile={this.props.profile}
        projects={objToArr(this.props.projects)}
        organizations={objToArr(this.props.organizations)}
        onLogoutClick={this.props.logout}
        onOrganizationClick={props => {
          this.props.setOrganization(props.id);
        }}
        onProjectClick={props => {
          this.props.push(`/editor/${props.id}`);
        }}
        currentOrganization={this.props.currentOrganizationId}
        match={this.props.match}
      >
        <PanelGroup
          borderColor={Styles.panelBorderColor}
          panelWidths={[
            { size: 250, minSize: 250, resize: "dynamic" },
            { minSize: 250, resize: "stretch" },
            { size: 300, minSize: 300, resize: "dynamic" }
          ]}
        >
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            {
              <ScenesPanel
                onClick={() => {
                  this.props.focusEditorPanel("scenes");
                }}
                hasFocus={this.props.editor.focusedPanel === "scenes"}
                title={"Available scenes"}
                titleEditable
                selected={sceneId}
                onCreate={this.onSceneCreate}
                items={scenes}
                onItemClick={this.onSceneSelect}
                onDelete={this.onSceneDelete}
                style={{ flex: 2, overflow: "hidden" }}
                disabledItems={disabledItems}
              />
            }
            {
              <LayersPanel
                onClick={() => {
                  this.props.focusEditorPanel("layers");
                }}
                hasFocus={this.props.editor.focusedPanel === "layers"}
                title="LAYERS"
                selected={layerId}
                onCreate={this.onLayerCreate}
                items={layers}
                onItemClick={this.onLayerSelect}
                onDelete={this.onLayerDelete}
                style={{ flex: 2, overflow: "hidden" }}
              />
            }
            <WidgetsPanel
              onClick={() => {
                this.props.focusEditorPanel("widgets");
              }}
              hasFocus={this.props.editor.focusedPanel === "widgets"}
              title="WIDGETS"
              selected={widgetId}
              onCreate={this.onWidgetCreate}
              onDelete={this.onWidgetDelete}
              onItemClick={this.onWidgetSelect}
              items={widgets}
              style={{ flex: 3, overflow: "hidden" }}
            />
          </div>
          <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
            <ProjectWidgets
              project={project}
              onItemClick={this.onPrefabSelect}
            />
            <PlayerContainer
              editor
              match={this.props.match}
              inEditor
              onPrefabDrop={this.onPrefabDrop}
            />
          </div>
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <Inspector
              match={this.props.match}
              project={project}
              onPrefabCreate={this.onPrefabCreate}
              onPrefabBreak={this.onPrefabBreak}
              onPrefabDelete={this.onPrefabDelete}
            />
          </div>
        </PanelGroup>
      </EditorLayout>
    );
  }
}

const populates = [
  { child: "createdBy", root: "users" },
  { child: "members", root: "users" },
  { child: "owners", root: "users" },
  { child: "prefab", root: "prefabs" }
];

function mapStateToProps({ firebase, router, editor, inspector }) {
  const { scene: sceneInspector = {} } = inspector;
  const { currentItemId: selectedSceneId = null } = sceneInspector;
  const { loadingScenes } = editor;
  return {
    auth: firebase.auth,
    projects: firebase.data.projects,
    projectsRequested: firebase.requested.projects,
    location: router.location,
    users: firebase.data.users,
    editor,
    loadingScenes,
    profile: firebase.profile,
    organizations: firebase.data.organizations,
    selectedSceneId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(ActionCreators, dispatch),
    push: path => {
      dispatch(push(path));
    }
  };
}

export default compose(
  connect(({ firebase, organizations }) => ({
    auth: firebase.auth,
    currentOrganizationId: organizations.currentOrganizationId
  })),
  firebaseConnect(props => [
    {
      path: "/organizations",
      populates,
      queryParams: [`orderByChild=members/${props.auth.uid}`, "equalTo=true"]
    }
  ]),
  firebaseConnect(
    props =>
      props.currentOrganizationId
        ? [
            {
              path: "/projects",
              queryParams: [
                `orderByChild=organizations/${props.currentOrganizationId}`,
                "equalTo=true"
              ]
            }
          ]
        : null
  ),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(windowSize(Editor));



// WEBPACK FOOTER //
// ./src/containers/Editor/Editor.js